
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/speaker/[...slug]",
      function () {
        return require("private-next-pages/speaker/[...slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/speaker/[...slug]"])
      });
    }
  